import { IUpdateCronogramaSGQUseCase } from "../../../presentation/useCases/update/updade_cronogramaSGQ_servicos_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";

// UpdateCronogramaSGQUseCase


export class UpdateCronogramaSGQUseCase implements IUpdateCronogramaSGQUseCase {
  constructor(private readonly repository: IQualidadeRepository) {}

  async updateCronogramaSGQ(IdCronogramaSGQ: number,
    Item: number | null,
    IdFuncionario: number | null,
    IdCentro_custo: number | null,
    Atividade: string,
    DescResponsavel: string,
    Observacao: string,
    ResponsavelCadastrado: boolean | null,
    DataPrevista: Date | null,
    DataRealizada: Date | null,
    DataPrevistaReal: Date | null,
    DataRealizadaReal: Date | null,
    ValorPrevisto: number | null,
    ValorRealizado: number | null,
  ): Promise<void> {
    
    await this.repository.updateCronogramaSGQ(
      IdCronogramaSGQ,
      Item,
      IdFuncionario,
      IdCentro_custo,
      Atividade,
      DescResponsavel,
      Observacao,
      ResponsavelCadastrado,
      DataPrevista,
      DataRealizada,
      DataPrevistaReal,
      DataRealizadaReal,
      ValorPrevisto,
      ValorRealizado,
    );
  }
}
